// @mui
import Stack from "@mui/material/Stack";
import ButtonMaterial from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
// components
import Iconify from "src/components/iconify";
import PropTypes from "prop-types";

// ----------------------------------------------------------------------

export default function Button({
  variant = "soft",
  color = "primary",
  size = "small",
  icon = null,
  text = null,
  tooltip = null,
  visible = true,
  sx = null,
  ...other
}) {
  const button = (
    <Tooltip title={tooltip}>
      <ButtonMaterial
        {...other}
        variant={variant}
        color={color}
        size={size}
      >
        {icon ? (
          <Iconify
            style={{ marginRight: text ? "4px" : null }}
            icon={icon}
          />
        ) : null}
        {text}
      </ButtonMaterial>
    </Tooltip>
  );

  return visible ? (
    sx != null ? (
      <Stack
        spacing={2}
        direction="row"
        sx={sx}
      >
        {button}
      </Stack>
    ) : (
      button
    )
  ) : null;
}

Button.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  visible: PropTypes.any,
  tooltip: PropTypes.string,
  text: PropTypes.string,
  sx: PropTypes.any,
};
